
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import LessonLayout from '../../components/mdx/LessonLayout'


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
  <LessonLayout title="Installing Linux on Chromebook">{children}</LessonLayout>
)

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`In order to install nodejs on a chromebook you must have linux enabled. If you
do not have linux enabled on your computer please follow the steps outlined
below.`}</p>
    <ul>
      <li parentName="ul">{`On the bottom left, click on the Launch button`}</li>
      <li parentName="ul">{`Type in Settings`}</li>
      <li parentName="ul">{`Click on Settings or press enter to open it`}</li>
      <li parentName="ul">{`On the left panel click on Linux (Beta)`}</li>
      <li parentName="ul">{`Click Turn On`}</li>
      <li parentName="ul">{`Click Install`}</li>
    </ul>
    <p>{`Note: You can also get to the Settings section by selecting time on the bottom
right and clicking on Settings.`}</p>
    <p>{`Once Linux has been successfully installed, the terminal should open up
automatically (if not, navigate to it by searching in the app Launcher). Check
for any updates by typing`}</p>
    <p><inlineCode parentName="p">{`sudo apt update`}</inlineCode></p>
    <p>{`Update any packages that need to be upgrated by typing`}</p>
    <p><inlineCode parentName="p">{`sudo apt upgrade`}</inlineCode></p>
    <h2 {...{
      "id": "step-2-install-nodejs"
    }}>{`Step 2 Install nodejs`}</h2>
    <p>{`You need to install NVM (Node Virtual Manager) before you can install nodejs.
Follow the steps listed below.`}</p>
    <h3 {...{
      "id": "install-nvm"
    }}>{`Install NVM`}</h3>
    <ul>
      <li parentName="ul">{`Got to the github repo for NVM`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/nvm-sh/nvm"
            }}>{`https://github.com/nvm-sh/nvm`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`Scroll down to the Table of Contents and click on Install and Upgrade Script`}</li>
      <li parentName="ul">{`Copy and paste the cURL command in the terminal, then press enter.`}</li>
    </ul>
    <h3 {...{
      "id": "install-nodejs"
    }}>{`Install nodejs`}</h3>
    <p>{`Note: Depending on when you are reading this, you may need to install a later
version of node. As of this example, node 10 will be installed.`}</p>
    <ul>
      <li parentName="ul">{`In the terminal type: `}<inlineCode parentName="li">{`nvm i 14`}</inlineCode></li>
    </ul>
    <p>{`Once all these is done, you should have node and npm installed. Type in
`}<inlineCode parentName="p">{`node -v`}</inlineCode>{` to double check.`}</p>
    <hr></hr>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;